import { render, staticRenderFns } from "./Zalohy.vue?vue&type=template&id=fe7667f4&"
import script from "./Zalohy.vue?vue&type=script&lang=ts&"
export * from "./Zalohy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports